import React, { useState, useEffect, useContext } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { FaEnvelope, FaLock, FaUser } from 'react-icons/fa';
import { PopupContext } from '../App';
import AuthLayout, { AuthFields, AuthFooter, AuthSubmitRow } from '../features/auth/components/AuthLayout';
import authStyles from '../features/auth/components/AuthLayout.module.css';
import Button from '../shared/ui/Button';
import Input from '../shared/ui/Input';
import axios from 'axios';
import { API_URL } from '../config/env';

export default function InviteAcceptPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [valid, setValid] = useState(null); // null=loading, true=valid, false=invalid
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const showPopup = useContext(PopupContext);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setValid(false);
      showPopup('Missing invite token', 'error');
      return;
    }
    setValid(true);
  }, [token, showPopup]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      showPopup('Passwords do not match', 'error');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/accept-invite`, { token, password, email, name });
      showPopup('Account created! You can now sign in.', 'success');
      navigate('/');
    } catch (err) {
      showPopup('Failed to accept invite', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (valid === false) {
    return (
      <AuthLayout
        tone="danger"
        title="Invalid invitation"
        subtitle="This invite link is missing, expired, or has already been accepted."
      >
        <p className={authStyles.errorHint}>Ask an administrator for a new invitation if you need access.</p>
        <AuthFooter>
          <Link className={authStyles.textLink} to="/login">
            Return to sign in
          </Link>
        </AuthFooter>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Accept invitation"
      subtitle="Create your account to sign in to Voucher Portal."
    >
      <form onSubmit={handleSubmit} noValidate>
        <AuthFields>
          <Input
            type="text"
            label="Full name"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            autoComplete="name"
            iconLeft={<FaUser />}
          />
          <Input
            type="email"
            label="Email"
            placeholder="you@school.org"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="email"
            iconLeft={<FaEnvelope />}
          />
          <Input
            type="password"
            label="Password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
            iconLeft={<FaLock />}
          />
          <Input
            type="password"
            label="Confirm password"
            placeholder="••••••••"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            autoComplete="new-password"
            iconLeft={<FaLock />}
          />
        </AuthFields>
        <AuthSubmitRow>
          <Button type="submit" size="lg" loading={loading}>
            Create account
          </Button>
        </AuthSubmitRow>
      </form>
    </AuthLayout>
  );
}
